<script>
import { showError } from '@/utils/notification'
import _c from '@/api/config'
import { useUserStore } from './stores/user'
import { isDev } from './utils'

export default {
  // 小程序有 globalData，这是一种简单的全局变量机制。这套机制在 uni-app 里也可以使用，并且全端通用。
  globalData: {
    // 请使用 pinia，项目中禁止使用 globalData
  },
  // 当 uni-app 初始化完成时触发（全局只触发一次）
  onLaunch: function(options) {
    if (!isDev) {
      this.initUser()
    }
  },
  // 当 uni-app 启动，或从后台进入前台显示
  onShow: function() {
  },
  // 当 uni-app 从前台进入后台
  onHide: function() {
  },
  methods: {
    initUser() {
      lightAppJssdk.user.getTicket({
        success: (data) => {
          if (data == '未登录') {
            this.openUserLogin()
          } else {
            const obj = JSON.parse(data)
            this.verifyTicket(obj.ticket)
          }
        },
        fail: (data) => {
          showError(data)
        }
      })
    },
    openUserLogin() {
      lightAppJssdk.user.loginapp({
        success: (data) => {
          if(data == '未登录') {
            this.closeWindow();
          } else {
            const obj = JSON.parse(data);
            this.verifyTicket(obj.ticket);
          }
        },
        fail: (data) => {
          this.closeWindow();
        }
      });
    },
    closeWindow() {
      lightAppJssdk.navigation.close({
        success: function(data) {},
        fail: function(data) {}
      });
    },
    verifyTicket(ticket) {
      const data = {
        key: _c.app_key,
        secret: _c.app_secret,
        ticket: ticket
      };
      lightAppJssdk.request.request({
        url: "http://www.jszwfw.gov.cn/jmopen/interfaces/UserAuth/verifyTicket.do",
        data: data,
        header: '',
        success: (data) => {
          console.log(JSON.stringify(data));
          if(data.result == "true") {
            this.verifyToken(data.token);
          } else {
            showError(data.errormsg);
          }
        },
        fail: (data) => {
          showError("获取令牌失败");
        }
      });
    },
    verifyToken(token) {
      console.log(token)
      const data = {
        key: _c.app_key,
        secret: _c.app_secret,
        token: token
      };
      lightAppJssdk.request.request({
        url: "http://www.jszwfw.gov.cn/jmopen/interfaces/UserAuth/verifyToken.do",
        data: data,
        header: '',
        success: (data) => {
          if(data.result == "true") {
            const user = JSON.parse(data.userdetail);
            const obj = {
              username: user.name,
              idNumber: user.cardid,
              mobile: user.mobile,
              ...user
            }
            const userStore = useUserStore()
            userStore.setUserInfo(obj)
          } else {
            showError("获取用户信息失败");
          }

        },
        fail: (data) => {
          showError("获取用户信息失败");
        }
      });
    }
  }
}
</script>

<style>
uni-page-head {
  display: none;
}
:deep(#app uni-page-head ~ uni-page-wrapper) {
  min-height: 100vh;
  height: 100%;
}
</style>